export const fadeDuration = 1.1
export const STORE_LINK = "https://unqueue.shop/store/pheal"